function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "shield"
}, /*#__PURE__*/React.createElement("path", {
  d: "m20 4c-2.162-.002-6.052-.467-7.293-1.707-.092-.092-.203-.165-.326-.216-.244-.102-.52-.102-.764 0-.123.051-.233.124-.326.216-1.24 1.24-5.13 1.705-7.291 1.707-.552 0-1 .448-1 1v9c0 4.391 7.638 7.538 8.608 7.92.002.001.004.001.005.002.005.002.017.007.021.009.118.046.242.069.366.069s.248-.023.365-.069c.005-.002.016-.007.021-.009.001-.001.003-.001.005-.002.971-.382 8.609-3.529 8.609-7.92v-9c0-.552-.448-1-1-1zm-1 7h-6v-6.205c1.963.856 4.564 1.108 6 1.178zm-8-6.205v6.205h-6v-5.027c1.436-.07 4.037-.322 6-1.178zm-6 9.205v-1h6v6.465c-2.375-1.147-6-3.346-6-5.465zm8 5.473v-6.473h6v1c0 1.969-3.27 4.17-6 5.473z"
}));

var Svg102Shield = function Svg102Shield(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg102Shield, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/102-shield.b5c0c535.svg";
export { ForwardRef as ReactComponent };